/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

document.addEventListener("DOMContentLoaded", function () {
  // Create a MutationObserver to watch for variant changes in the DOM
  function setupVariantChangeDetection() {
    console.log("Setting up variant change detection");

    // 1. Direct event capture method - using a custom document-level event
    document.addEventListener("variant_change", function (event) {
      console.log("Direct variant_change event captured:", event);
      var variant = null;

      // Try to get variant from event detail or arguments
      if (event.detail && event.detail.variant) {
        variant = event.detail.variant;
      } else if (arguments.length > 2) {
        variant = arguments[2]; // Third parameter in older event systems
      }

      if (variant && variant.id) {
        updateSlideForVariant(variant.id);
      }
    });

    // 2. Observe the active variant option selection in the DOM
    var productOptions = document.querySelectorAll(
      '[data-option-select], [name^="option-"]'
    );
    productOptions.forEach(function (option) {
      option.addEventListener("change", function () {
        console.log("Product option changed:", this.value);
        setTimeout(checkSelectedVariant, 100); // Small delay to let the theme process the change
      });
    });

    // 3. Look for URL changes which might indicate variant changes
    var currentUrl = window.location.href;
    setInterval(function () {
      if (currentUrl !== window.location.href) {
        currentUrl = window.location.href;
        console.log("URL changed, checking for variant parameter");
        var urlParams = new URLSearchParams(window.location.search);
        var variantId = urlParams.get("variant");
        if (variantId) {
          updateSlideForVariant(variantId);
        }
      }
    }, 200);

    // 4. Watch for changes to variant-specific elements
    var productForm = document.querySelector(".product-form");
    if (productForm) {
      var observer = new MutationObserver(function (mutations) {
        var shouldCheckVariant = mutations.some(function (mutation) {
          return (
            mutation.type === "attributes" ||
            (mutation.type === "childList" && mutation.addedNodes.length > 0)
          );
        });

        if (shouldCheckVariant) {
          console.log("Product form changed, checking selected variant");
          setTimeout(checkSelectedVariant, 100);
        }
      });

      observer.observe(productForm, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }
  }

  // Function to check which variant is currently selected
  function checkSelectedVariant() {
    console.log("Checking selected variant");

    // Try to get variant ID from a variety of possible sources
    var variantId = null;

    // 1. Check URL parameter
    var urlParams = new URLSearchParams(window.location.search);
    variantId = urlParams.get("variant");

    // 2. Check hidden input that might store selected variant
    if (!variantId) {
      var variantInput = document.querySelector(
        '[name="id"], [name="variant_id"]'
      );
      if (variantInput && variantInput.value) {
        variantId = variantInput.value;
      }
    }

    // 3. Check active variant elements
    if (!variantId) {
      var activeVariant = document.querySelector(
        '.variant--active, [aria-selected="true"]'
      );
      if (activeVariant) {
        variantId =
          activeVariant.getAttribute("data-variant-id") ||
          activeVariant.getAttribute("id") ||
          activeVariant.getAttribute("value");
      }
    }

    if (variantId) {
      console.log("Found selected variant ID:", variantId);
      updateSlideForVariant(variantId);
    } else {
      console.log("Could not determine selected variant");
    }
  }

  // Function to update the slider for a specific variant
  function updateSlideForVariant(variantId) {
    console.log("Updating slide for variant ID:", variantId);

    // Find the product-media-gallery component
    var galleryComponent = document.querySelector("product-media-gallery");
    if (!galleryComponent || !galleryComponent.mainSwiper) {
      console.log("Gallery component or swiper not found/initialized");
      return;
    }

    // Find the slide with the matching variant ID
    var slides = galleryComponent.mainEl.querySelectorAll(".swiper-slide");
    console.log("Looking for slide with variant ID:", variantId);
    console.log("Available slides:", slides.length);

    // Debug: Log all slide variant IDs
    for (var i = 0; i < slides.length; i++) {
      var slideVariantId = slides[i].getAttribute("data-variant-id");
      console.log("Slide " + i + " has variant ID: " + slideVariantId);
    }

    // Find and navigate to the matching slide
    var foundMatchingSlide = false;
    for (var j = 0; j < slides.length; j++) {
      var slideVariantId = slides[j].getAttribute("data-variant-id");

      // Compare as strings to avoid type issues
      if (slideVariantId && String(slideVariantId) === String(variantId)) {
        console.log("Sliding to variant " + variantId + " at index " + j);
        try {
          galleryComponent.mainSwiper.slideTo(j);
          foundMatchingSlide = true;
          break;
        } catch (error) {
          console.error("Error sliding to variant:", error);
        }
      }
    }

    if (!foundMatchingSlide) {
      console.log("No slide found for variant ID: " + variantId);
    }
  }

  // Set up all the variant change detection methods
  setupVariantChangeDetection();

  // Check for initial variant on page load
  setTimeout(function () {
    checkSelectedVariant();
  }, 500);

  // Debug output to confirm script is loaded
  console.log("Variant change handler initialized");
});

class ProductMediaGallery extends HTMLElement {
  constructor() {
    super();
    this.mainSwiper = null;
    this.thumbsSwiper = null;
    this.mainEl = this.querySelector("product-media-gallery-main");
    this.thumbsEl = this.querySelector("product-media-gallery-thumbs");
    this.videos = [];
    this.variantChangeHandler = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    if (typeof Swiper !== "undefined") {
      this.initSwipers();
      this.findVideos();
      this.addModalEventListener();

      // Add variant change listener
      document.addEventListener("variant:changed", this.variantChangeHandler);
    } else {
      // Wait for Swiper to load
      window.addEventListener("load", () => {
        if (typeof Swiper !== "undefined") {
          this.initSwipers();
          this.findVideos();
          this.addModalEventListener();

          // Add variant change listener
          document.addEventListener(
            "variant:changed",
            this.variantChangeHandler
          );
        } else {
          console.error(
            "Swiper library could not be loaded for ProductMediaGallery"
          );
        }
      });
    }
  }

  disconnectedCallback() {
    this.destroySwipers();
    this.removeModalEventListener();

    // Remove variant change listener
    document.removeEventListener("variant:changed", this.variantChangeHandler);
  }

  // Handle variant change event
  handleVariantChange(event) {
    console.log("productmediagallery // variant change event", event);
    if (!event.detail || !event.detail.variantId || !this.mainSwiper) return;

    const variantId = event.detail.variantId;
    const slides = this.mainEl.querySelectorAll(".swiper-slide");

    for (let i = 0; i < slides.length; i++) {
      const slide = slides[i];
      const slideVariantId = slide.getAttribute("data-variant-id");

      if (slideVariantId && slideVariantId == variantId) {
        this.mainSwiper.slideTo(i);
        return;
      }
    }
  }

  initSwipers() {
    const thumbsOptions = this.getThumbsOptions();
    this.thumbsSwiper = new Swiper(this.thumbsEl, thumbsOptions);

    const mainOptions = this.getMainOptions();
    this.mainSwiper = new Swiper(this.mainEl, mainOptions);

    // Add event listeners for slide change
    this.mainSwiper.on("slideChange", () => this.handleSlideChange());
    this.mainSwiper.on("slideChangeTransitionEnd", () =>
      this.handleSlideChangeEnd()
    );
  }

  destroySwipers() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy(true, true);
      this.mainSwiper = null;
    }
    if (this.thumbsSwiper) {
      this.thumbsSwiper.destroy(true, true);
      this.thumbsSwiper = null;
    }
  }

  reinitSwipers() {
    this.destroySwipers();
    this.initSwipers();
  }

  getThumbsOptions() {
    return {
      spaceBetween: 5,
      slidesPerView: 5,
      // freeMode: true,
      // slidesPerView: 5,
      centerInsufficientSlides: true,
      watchSlidesProgress: true,
      breakpoints: {
        750: {
          slidesPerView: 5,
        },
        990: {
          slidesPerView: "auto",
        },
      },
    };
  }

  getMainOptions() {
    const options = this.getOptions(); // Your existing getOptions method

    // Add thumbs configuration
    options.thumbs = {
      swiper: this.thumbsSwiper,
    };

    // options.pagination = {
    //   el: "product-media-gallery-progressbar",
    //   type: "progressbar",
    // };

    options.navigation = {
      nextEl: "product-media-gallery-next",
      prevEl: "product-media-gallery-prev",
    };

    return options;
  }

  getOptions() {
    const getAttributeValue = (attr, fallback) => {
      return this.hasAttribute(attr) ? this.getAttribute(attr) : fallback;
    };

    const parseSlidesPerView = (value) => {
      return value === "auto" ? "auto" : parseFloat(value) || 1;
    };

    const defaults = {
      autoHeight: true,
      cols: getAttributeValue("cols", "1"),
      spaceBetween: getAttributeValue("space-between", "0"),
    };

    const baseOptions = {
      slidesPerView: parseSlidesPerView(defaults.cols),
      spaceBetween: parseInt(defaults.spaceBetween),
      grabCursor: true,
      centeredSlides: defaults.centeredSlides,
    };

    const breakpoints = {};
    const breakpointSettings = [
      { point: 0, suffix: "" },
      { point: 768, suffix: "md" },
      { point: 1024, suffix: "lg" },
      { point: 1280, suffix: "xl" },
    ];

    let currentOptions = { ...defaults };

    breakpointSettings.forEach(({ point, suffix }) => {
      const breakpointOptions = {
        slidesPerView: parseSlidesPerView(
          getAttributeValue(
            `cols${suffix ? "-" + suffix : ""}`,
            currentOptions.slidesPerView
          )
        ),
        spaceBetween:
          parseInt(
            getAttributeValue(
              `space-between${suffix ? "-" + suffix : ""}`,
              currentOptions.spaceBetween
            )
          ) || 0,

        centeredSlides:
          this.hasAttribute(`centered-slides${suffix ? "-" + suffix : ""}`) ||
          currentOptions.centeredSlides,
      };

      currentOptions = { ...currentOptions, ...breakpointOptions };
      breakpoints[point] = { ...currentOptions };
    });

    const options = {
      ...baseOptions,
      breakpoints,
    };

    if (this.hasAttribute("pagination")) {
      options.pagination = {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
        type: this.getAttribute("pagination-type") || "bullets",
      };
    }

    if (this.hasAttribute("navigation")) {
      options.navigation = {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      };
    }

    if (this.hasAttribute("autoplay")) {
      options.autoplay = {
        delay: parseInt(this.getAttribute("autoplay") || 3000),
        disableOnInteraction: false,
      };
    }

    if (this.hasAttribute("loop")) {
      options.loop = true;
    }

    return options;
  }

  findVideos() {
    this.videos = Array.from(this.mainEl.querySelectorAll("video"));
  }

  handleSlideChange() {
    // Pause all videos when slide starts changing
    this.videos.forEach((video) => video.pause());
  }

  handleSlideChangeEnd() {
    // Play video on the current slide if it exists
    const currentSlide = this.mainSwiper.slides[this.mainSwiper.activeIndex];
    const video = currentSlide.querySelector("video");
    if (video) {
      video.play();
      video.muted = false;
    }
  }

  pauseAllVideos() {
    this.videos.forEach((video) => video.pause());
  }

  addModalEventListener() {
    this.handleModalOpen = this.handleModalOpen.bind(this);
    document.addEventListener(
      "product-media-gallery:modal-open",
      this.handleModalOpen
    );
  }

  removeModalEventListener() {
    document.removeEventListener(
      "product-media-gallery:modal-open",
      this.handleModalOpen
    );
  }

  handleModalOpen(event) {
    // Pause the currently active video when the modal is opened
    if (event.detail && event.detail.isOpen) {
      this.pauseAllVideos();
    }
  }

  static get observedAttributes() {
    return [
      "cols",
      "cols-md",
      "cols-lg",
      "cols-xl",
      "space-between",
      "space-between-md",
      "space-between-lg",
      "space-between-xl",
      "pagination",
      "navigation",
      "autoplay",
      "loop",
      "grid",
      "grid-md",
      "grid-lg",
      "grid-xl",
      "grid-rows",
      "grid-rows-md",
      "grid-rows-lg",
      "grid-rows-xl",
      "centered-slides",
      "centered-slides-md",
      "centered-slides-lg",
      "centered-slides-xl",
      "thumbs-slides-per-view",
      "thumbs-space-between",
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (this.mainSwiper || this.thumbsSwiper) {
      this.reinitSwipers();
    }
  }
}

window.customElements.define("product-media-gallery", ProductMediaGallery);

class UICarousel extends HTMLElement {
  constructor() {
    super();
    this.validPaginationTypes = [
      "progressbar",
      "bullets",
      "fraction",
      "custom",
    ];
    this.validEffects = ["slide", "fade", "cube", "coverflow", "flip", "cards"];

    this.defaultConfig = {
      loop: false,
      slidesPerView: this.dataset.slidesPerView
        ? parseFloat(this.dataset.slidesPerView)
        : 1,
      spaceBetween: this.dataset.spaceBetween
        ? parseInt(this.dataset.spaceBetween, 10)
        : 30,
    };
  }

  connectedCallback() {
    if (typeof Swiper !== "undefined") {
      this.initializeSwiper(this.getMergedConfig());
    } else {
      // Wait for Swiper to load
      window.addEventListener("load", () => {
        if (typeof Swiper !== "undefined") {
          this.initializeSwiper(this.getMergedConfig());
        } else {
          console.error("Swiper library could not be loaded");
        }
      });
    }
  }

  getMergedConfig() {
    const config = {
      ...this.defaultConfig,
      ...this.getNavigationConfig(),
      ...this.getPaginationConfig(),
      ...this.getEffectConfig(),
      ...this.getBreakpointsConfig(),
      ...this.getCustomConfig(),
    };

    return config;
  }

  getBreakpointsConfig() {
    // Initialize breakpoints object
    const breakpoints = {};

    // Add tablet breakpoint (768px)
    if (this.hasAttribute("data-tablet-slides")) {
      const tabletSlides = parseFloat(this.dataset.tabletSlides || 4);
      const tabletBreakpoint = parseInt(
        this.dataset.tabletBreakpoint || 768,
        10
      );
      const tabletSpaceBetween = parseInt(
        this.dataset.tabletSpaceBetween || 20,
        10
      );

      breakpoints[tabletBreakpoint] = {
        slidesPerView: tabletSlides,
        spaceBetween: tabletSpaceBetween,
      };
    }

    // Add desktop breakpoint (1024px)
    if (this.hasAttribute("data-desktop-slides")) {
      const desktopSlides = parseFloat(this.dataset.desktopSlides || 4);
      const desktopBreakpoint = parseInt(
        this.dataset.desktopBreakpoint || 1024,
        10
      );
      const desktopSpaceBetween = parseInt(
        this.dataset.desktopSpaceBetween || 30,
        10
      );

      breakpoints[desktopBreakpoint] = {
        slidesPerView: desktopSlides,
        spaceBetween: desktopSpaceBetween,
      };
    }

    // Return breakpoints config if any breakpoints were defined
    return Object.keys(breakpoints).length > 0 ? { breakpoints } : {};
  }

  // Rest of the methods remain the same
  getNavigationConfig() {
    // Simple presence check for the attribute
    if (this.hasAttribute("data-navigation")) {
      return {
        navigation: {
          nextEl: ".ui-carousel-next",
          prevEl: ".ui-carousel-prev",
        },
      };
    }
    return {};
  }

  getPaginationConfig() {
    const paginationType = this.dataset.pagination;

    if (!paginationType) return {};

    if (!this.validPaginationTypes.includes(paginationType)) {
      console.warn(
        `Invalid pagination type "${paginationType}". Using default "bullets" type. ` +
          `Valid types are: ${this.validPaginationTypes.join(", ")}`
      );
      return {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets",
          dynamicMainBullets: 1,
        },
      };
    }

    return {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: paginationType,
        dynamicMainBullets: 1,
      },
    };
  }

  getEffectConfig() {
    const effect = this.dataset.effect;
    if (!effect) return {};

    if (!this.validEffects.includes(effect)) {
      console.warn(
        `Invalid effect "${effect}". Using default "slide" effect. ` +
          `Valid effects are: ${this.validEffects.join(", ")}`
      );
      return {};
    }

    // Base effect configuration
    const effectConfig = {
      effect: effect,
    };

    // Add effect-specific parameters
    if (effect === "cards") {
      effectConfig.cardsEffect = {
        slideShadows: this.dataset.slideShadows !== "false",
        rotate: this.dataset.rotate ? parseFloat(this.dataset.rotate) : 0,
        perSlideOffset: this.dataset.perSlideOffset
          ? parseFloat(this.dataset.perSlideOffset)
          : 8,
      };
    } else if (effect === "coverflow") {
      effectConfig.coverflowEffect = {
        rotate: this.dataset.rotate ? parseFloat(this.dataset.rotate) : 50,
        stretch: this.dataset.stretch ? parseFloat(this.dataset.stretch) : 0,
        depth: this.dataset.depth ? parseFloat(this.dataset.depth) : 100,
        modifier: this.dataset.modifier ? parseFloat(this.dataset.modifier) : 1,
        slideShadows: this.dataset.slideShadows !== "false",
      };
    } else if (effect === "cube") {
      effectConfig.cubeEffect = {
        slideShadows: this.dataset.slideShadows !== "false",
        shadow: this.dataset.shadow !== "false",
        shadowOffset: this.dataset.shadowOffset
          ? parseFloat(this.dataset.shadowOffset)
          : 20,
        shadowScale: this.dataset.shadowScale
          ? parseFloat(this.dataset.shadowScale)
          : 0.94,
      };
    } else if (effect === "flip") {
      effectConfig.flipEffect = {
        slideShadows: this.dataset.slideShadows !== "false",
        limitRotation: this.dataset.limitRotation !== "false",
      };
    }

    return effectConfig;
  }

  // getCustomConfig() {
  //   // Method to be overridden by child classes for custom configuration

  //   if (this.hasAttribute("data-grab-cursor")) {
  //     return {
  //       grabCursor: true,
  //     };
  //   }
  //   return {};
  // }

  getCustomConfig() {
    const config = {};

    // Check for grab cursor
    if (this.hasAttribute("data-grab-cursor")) {
      config.grabCursor = true;
    }

    // Check for auto height
    if (this.hasAttribute("data-auto-height")) {
      config.autoHeight = true;
    }

    return config;
  }

  initializeSwiper(config) {
    this.swiper = new Swiper(this, config);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

customElements.define("ui-carousel", UICarousel);

class CardCarousel extends UICarousel {
  constructor() {
    super();
    // Bind the setupCardOpacity method to this instance
    this.setupCardOpacity = this.setupCardOpacity.bind(this);
  }

  getCustomConfig() {
    // Add specific configuration for testimonials
    return {
      grabCursor: true,
      effect: "cards",
      cardsEffect: {
        perSlideOffset: 10,
        slideShadows: true, // Keep shadows for proper effect
        perSlideRotate: 1,
      },
      autoplay: this.hasAttribute("data-autoplay")
        ? {
            delay: this.dataset.autoplayDelay || 3000,
            disableOnInteraction: false,
          }
        : false,
      on: {
        init: (swiper) => {
          this.setupCardOpacity(swiper);
        },
        slideChange: (swiper) => {
          this.setupCardOpacity(swiper);
        },
      },
    };
  }

  setupCardOpacity(swiper) {
    // Get all slides
    const slides = swiper.slides;
    const activeIndex = swiper.activeIndex;

    // Apply custom opacity for each slide
    slides.forEach((slide, index) => {
      let distance = Math.abs(index - activeIndex); // Absolute distance from active slide

      // Reset shadow opacity first
      const shadow = slide.querySelector(".swiper-slide-shadow-cards");

      if (distance === 0) {
        // Active card is fully opaque
        slide.style.opacity = "1";

        // No shadow on active card when not being dragged
        if (shadow) {
          shadow.style.opacity = "0";
        }
      } else {
        // Both previous and next slides get opacity treatment
        // Calculate opacity: active is 1, then 0.8, 0.6, 0.4, 0.2
        const opacity = Math.max(0.2, 1 - distance * 0.2);
        slide.style.opacity = opacity;

        // Also adjust shadow opacity if it exists
        if (shadow) {
          shadow.style.opacity = "0.5"; // Consistent shadow for non-active cards
        }
      }
    });
  }

  // Override the initializeSwiper method to add extra styles
  initializeSwiper(config) {
    super.initializeSwiper(config);

    // Add event listener for drag events to handle shadows properly
    if (this.swiper) {
      this.swiper.on("touchStart", () => {
        // When dragging starts, we might want to adjust shadow visibility
        const activeSlide = this.swiper.slides[this.swiper.activeIndex];
        const shadow = activeSlide.querySelector(".swiper-slide-shadow-cards");
        if (shadow) {
          shadow.style.transition = "opacity 0.3s";
          shadow.style.opacity = "0.3"; // Show some shadow when dragging
        }
      });

      this.swiper.on("touchEnd", () => {
        // Reset after drag
        setTimeout(() => this.setupCardOpacity(this.swiper), 300);
      });
    }
  }
}

customElements.define("card-carousel", CardCarousel);

/**
 * Custom Accordion Web Component
 * Features:
 * - Smooth height animations
 * - Single-open functionality
 * - Immediate color transitions when switching accordions
 * - Resize handling with debouncing
 * - Proper cleanup of event listeners
 */

class UIAccordion extends HTMLElement {
  connectedCallback() {
    const details = this.querySelector("details");
    const content = details.querySelector(".ui-accordion__content");
    const summary = details.querySelector("summary");

    // Initialize height based on open state
    if (details.open) {
      this.classList.add("active");
      content.style.height = "auto";
    } else {
      content.style.height = "0";
    }

    summary.addEventListener("click", (e) => {
      e.preventDefault();

      if (details.open) {
        // Closing animation
        this.closeAccordion(content, details);
      } else {
        // Close other accordions in the same parent container
        this.closeOtherAccordions();

        // Opening animation
        this.openAccordion(content, details);
      }
    });
  }

  openAccordion(content, details) {
    // Opening animation
    details.open = true;
    this.classList.add("active");
    const endHeight = content.scrollHeight;

    content.style.height = "0";
    void content.offsetHeight; // Force reflow
    content.style.height = `${endHeight}px`;

    content.addEventListener(
      "transitionend",
      () => {
        content.style.height = "auto";
      },
      { once: true }
    );
  }

  closeAccordion(content, details) {
    this.classList.remove("active");
    const startHeight = content.scrollHeight;
    content.style.height = `${startHeight}px`;

    void content.offsetHeight; // Force reflow
    content.style.height = "0";

    content.addEventListener(
      "transitionend",
      () => {
        details.open = false;
      },
      { once: true }
    );
  }

  closeOtherAccordions() {
    const parentContainer = this.closest("div"); // Adjust selector to your parent container
    if (parentContainer) {
      const otherAccordions = parentContainer.querySelectorAll(
        "ui-accordion:not(:scope)"
      );
      otherAccordions.forEach((accordion) => {
        const otherDetails = accordion.querySelector("details");
        const otherContent = accordion.querySelector(".ui-accordion__content");
        if (otherDetails.open) {
          accordion.closeAccordion(otherContent, otherDetails);
        }
      });
    }
  }
}

customElements.define("ui-accordion", UIAccordion);

class QuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.variantId = null;
    this.button = null;
    this.isUpdating = false;
  }

  connectedCallback() {
    this.variantId = this.getAttribute("data-variant-id");
    if (!this.variantId) {
      console.error("Quick add button requires a data-variant-id attribute");
      return;
    }
    this.setupButton();
    this.attachEventListeners();
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener("click", this.handleAddToCart);
    }
  }

  static get observedAttributes() {
    return ["data-variant-id"];
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === "data-variant-id" && oldVal !== newVal) {
      this.variantId = newVal;
    }
  }

  setupButton() {
    this.button = this.querySelector("button");
    if (!this.button) {
      console.error("Quick add button requires a button element as child");
      return;
    }
    // Store original text to restore after adding to cart
    this.button.originalText = this.button.textContent;
  }

  attachEventListeners() {
    this.handleAddToCart = this.handleAddToCart.bind(this);
    this.button.addEventListener("click", this.handleAddToCart);
  }

  handleAddToCart(event) {
    event.preventDefault();

    if (this.isUpdating) {
      return;
    }

    this.isUpdating = true;
    this.button.classList.add("btn--loading");

    // Add item to cart
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        id: this.variantId,
        quantity: 1,
      }),
    })
      .then((response) => response.json())
      .then((item) => {
        // Update button state
        this.button.classList.remove("btn--loading");
        this.button.classList.add("btn--added");
        this.button.textContent = "Added!";

        // Get the complete cart data
        return fetch("/cart.js").then((res) => res.json());
      })
      .then((cart) => {
        // Update the cart bubble
        this.updateCartBubble(cart);

        // Refresh the entire cart drawer with the latest content
        return this.refreshCartDrawer(cart);
      })
      .then(() => {
        // Open the cart drawer
        setTimeout(() => {
          this.openCartDrawer();
        }, 300);

        // Reset button after delay
        setTimeout(() => {
          this.button.classList.remove("btn--added");
          this.button.textContent = this.button.originalText;
          this.isUpdating = false;
        }, 2000);
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
        this.button.classList.remove("btn--loading");
        this.button.textContent = "Error";

        setTimeout(() => {
          this.button.textContent = this.button.originalText;
          this.isUpdating = false;
        }, 2000);
      });
  }

  updateCartBubble(cart) {
    const $bubble = document.querySelector(".site-header__cart-bubble");
    if ($bubble) {
      if (cart.items.length !== 0) {
        $bubble.classList.add("site-header__cart-bubble--visible");
        $bubble.classList.add("bubble-pulse");

        // Remove pulse animation after completion
        setTimeout(() => {
          $bubble.classList.remove("bubble-pulse");
        }, 1000);
      } else {
        $bubble.classList.remove("site-header__cart-bubble--visible");
      }
    }
  }

  refreshCartDrawer(cart) {
    // Get the fresh cart drawer HTML
    return fetch("/?sections=cart-drawer")
      .then((response) => response.json())
      .then((sections) => {
        if (!sections["cart-drawer"]) {
          console.warn("No cart drawer section found in response");
          return;
        }

        // Find the cart drawer element
        const cartDrawer = document.querySelector(
          '.drawer[data-section-id="cart-drawer"]'
        );
        if (!cartDrawer) {
          console.warn("Cart drawer element not found");
          return;
        }

        // Parse the fresh HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(
          sections["cart-drawer"],
          "text/html"
        );

        // Update specific elements based on your drawer structure
        this.updateCartDrawerElements(cartDrawer, doc, cart);
      });
  }

  updateCartDrawerElements(cartDrawer, doc, cart) {
    // Update empty state class
    if (cart.items.length === 0) {
      cartDrawer.querySelector("form").classList.add("cart-drawer--empty");
    } else {
      cartDrawer.querySelector("form").classList.remove("cart-drawer--empty");
    }

    // Update item list
    const currentItemList = cartDrawer.querySelector("[data-cart-item-list]");
    const newItemList = doc.querySelector("[data-cart-item-list]");

    if (currentItemList && newItemList) {
      // Replace the entire item list content
      currentItemList.innerHTML = newItemList.innerHTML;

      // Re-initialize quantity inputs if needed
      const quantityInputs = currentItemList.querySelectorAll(
        "[data-cart-item-input-quantity]"
      );
      quantityInputs.forEach((input) => {
        input.addEventListener("change", this.handleQuantityChange);
      });
    }

    // Update subtotal
    const subtotalElement = cartDrawer.querySelector("[data-cart-subtotal]");
    const newSubtotalElement = doc.querySelector("[data-cart-subtotal]");

    if (subtotalElement && newSubtotalElement) {
      subtotalElement.innerHTML = newSubtotalElement.innerHTML;
    }

    // Update discount section if it exists
    const discountContainer = cartDrawer.querySelector(
      "[data-cart-discount-container]"
    );
    const newDiscountContainer = doc.querySelector(
      "[data-cart-discount-container]"
    );

    if (discountContainer && newDiscountContainer) {
      discountContainer.innerHTML = newDiscountContainer.innerHTML;
    }

    // Enable/disable checkout button
    const checkoutButton = cartDrawer.querySelector("[data-cart-submit]");
    if (checkoutButton) {
      checkoutButton.disabled = cart.items.length === 0;
    }
  }

  handleQuantityChange(event) {
    // This would handle quantity changes if you need to manage that
    // Left as a placeholder
  }

  openCartDrawer() {
    // Try clicking the cart toggle button first
    const cartToggle = document.querySelector(".ajax-cart__toggle");
    if (cartToggle) {
      cartToggle.click();
      return;
    }

    // If no toggle button, try to open the drawer manually
    const cartDrawer = document.querySelector(
      '.drawer[data-section-id="cart-drawer"]'
    );
    if (cartDrawer) {
      // Add the necessary classes
      document.body.classList.add("drawer--active");
      cartDrawer.classList.add("drawer--active");
      cartDrawer.setAttribute("aria-hidden", "false");

      // Disable scrolling
      document.documentElement.classList.add("disable-scroll");

      // Enable tabbing in the drawer
      const drawerElements = cartDrawer.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      drawerElements.forEach((el) => {
        el.setAttribute("tabindex", "0");
      });
    }
  }
}

customElements.define("quick-add-button", QuickAddButton);

class ViewportVideo extends HTMLElement {
  constructor() {
    super();
    this.previewImage = null;
    this.video = null;
    this.observer = null;
  }

  connectedCallback() {
    this.initializeVideo();
    this.initializePreviewImage();
    this.setupIntersectionObserver();
  }

  disconnectedCallback() {
    this.disconnectIntersectionObserver();
  }

  initializeVideo() {
    this.video = this.querySelector("video.section-video");
    if (this.video) {
      this.video.pause(); // Ensure the video starts paused
      this.video.style.display = "none"; // Hide the video initially
    }
  }

  initializePreviewImage() {
    this.previewImage = this.querySelector("img.section-image");
    if (!this.previewImage) {
      this.previewImage = document.createElement("img");
      this.previewImage.src = this.getAttribute("data-poster") || "";
      this.previewImage.alt = "Video Preview";
      this.previewImage.classList.add("section-image");
      this.previewImage.style.width = "100%";
      this.previewImage.style.height = "auto";
      this.appendChild(this.previewImage);
    }
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log("Video is in view");
          this.video.style.display = "block"; // Show the video
          this.previewImage.style.display = "none"; // Hide the preview image
          this.video.play(); // Play the video
        } else {
          console.log("Video is out of view");
          this.video.style.display = "none"; // Hide the video
          this.previewImage.style.display = "block"; // Show the preview image
          this.video.pause(); // Pause the video
        }
      });
    }, options);

    this.observer.observe(this);
  }

  disconnectIntersectionObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

window.customElements.define("viewport-video", ViewportVideo);
